import { render, staticRenderFns } from "./DrawerNavigationMobile.vue?vue&type=template&id=36f5001a&"
import script from "./DrawerNavigationMobile.vue?vue&type=script&lang=js&"
export * from "./DrawerNavigationMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports